import React from 'react'

export const Header = () => {
    return (
        <div className="header">
            <h1>React Export to Excel Example</h1>
        </div>
    )
}